import PropTypes from 'prop-types';
import { Modal } from 'antd';
import styled from 'styled-components';

const CustomModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    width: 780px;
  }
  .ant-modal-footer {
    display: flex;
    justify-content: right;
    gap: 15px;
  }
`;
export const HSModal = ({
  open,
  handleOk,
  handleCancel,
  content,
  title,
  footer,
  hideCloseBtn = false,
  className = '',
}) => {
  return (
    <CustomModal
      className={className}
      open={open}
      title={title}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={footer}
      closable={hideCloseBtn}
    >
      {content}
    </CustomModal>
  );
};

HSModal.propTypes = {
  handleOk: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  content: PropTypes.any.isRequired,
  title: PropTypes.any.isRequired,
  footer: PropTypes.any.isRequired,
  className: PropTypes.string,
  hideCloseBtn: PropTypes.bool,
};
